module.exports = __webpack_public_path__ + "static/media/11.d01faf1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/11.png
// module id = 693
// module chunks = 0